import styled from 'styled-components';

export const CustomSpace = styled.div`
  height: 16px;
  width: 100%;
  /* background-color: red; */
`;
